import { OFFLINE_SHARE_OFFER_REPORTS_FETCHED_SUCCESS } from '../constants/actionTypes';

const initialState = {
  offline_share_offers: [],
  message: '',
  pager: {
    current: 1,
    pageSize: 15,
    total: 0,
  },
  role: {
    message: '',
  },
};

export default (state = initialState, action) => {
  switch (action.type) {
    case OFFLINE_SHARE_OFFER_REPORTS_FETCHED_SUCCESS:
      return {
        ...state,
        OfflineShareOffer: action.payload.OfflineShareOffer,
        pager: action.payload.pager,
      };

    default:
      return state;
  }
};
